/**
 * Known AI assistant origins for first-touch acquisition attribution (GEO PBI).
 *
 * When a visitor arrives from one of these hosts with no ad click id or UTM in
 * the URL, we persist utmSource = host and utmMedium = ai_assistant so signups
 * from ChatGPT / Perplexity / etc. are distinguishable in reporting.
 */

/** utm_medium value stored on User when traffic came from an AI assistant referrer. */
export const AI_ASSISTANT_UTM_MEDIUM = 'ai_assistant';

/**
 * Referrer hostnames (lowercase) we treat as AI-assistant traffic.
 * Include www variants where browsers commonly send them.
 */
export const AI_ASSISTANT_REFERRER_HOSTS: readonly string[] = [
  'chatgpt.com',
  'www.chatgpt.com',
  'chat.openai.com',
  'perplexity.ai',
  'www.perplexity.ai',
  'gemini.google.com',
  'claude.ai',
  'www.claude.ai',
  'copilot.microsoft.com',
  'www.copilot.microsoft.com',
] as const;

const AI_ASSISTANT_HOST_SET = new Set(
  AI_ASSISTANT_REFERRER_HOSTS.map((h) => h.toLowerCase()),
);

/**
 * Returns the normalized host when it matches a known AI assistant origin.
 */
export const normalizeAiAssistantReferrerHost = (hostname: string): string | null => {
  const normalized = hostname.trim().toLowerCase();
  if (!normalized || !AI_ASSISTANT_HOST_SET.has(normalized)) {
    return null;
  }

  return normalized;
};
